import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ProgressButton } from '../../../../core/components';
import Price from '../../../../core/components/price';
export const PaymentButtons = ({ onBack, onPay, isDisabled, isLoading, totalWithTax, currencyCode, }) => {
    return (<div className="payment-setup__progress-buttons">
      <button type="button" className="button button--stroke show-hide-btn payment-setup__go-back-btn sign-up__go-back-button-v2" onClick={onBack}>
        <FormattedMessage id="auth.payment-setup.back"/>
      </button>

      <ProgressButton className={classNames('payment-setup__submit-btn btn btn-primary progress-button space-md-bottom payment-setup__submit-btn-v2', {
            'payment-setup__progress-button--disabled payment-setup__submit-btn-v2--disabled': isDisabled,
        })} type="submit" validation-submit="form" data-test-id="payment-setup-submit" isLoading={isLoading} disabled={isDisabled} onClick={onPay}>
        <span className="payment-setup__pay">
          <FormattedMessage id="auth.payment-setup.submit"/>
          &nbsp;
          <span className="payment-setup__payment-total">
            <Price item={totalWithTax} currency={currencyCode} showDecimals={true}/>
          </span>
        </span>
      </ProgressButton>
    </div>);
};
